import { render, staticRenderFns } from "./wcListFooter.vue?vue&type=template&id=31462552&scoped=true"
import script from "./wcListFooter.vue?vue&type=script&lang=js"
export * from "./wcListFooter.vue?vue&type=script&lang=js"
import style0 from "./wcListFooter.vue?vue&type=style&index=0&id=31462552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31462552",
  null
  
)

export default component.exports